import { render } from "./CreateIsolatedNetworkForm.vue?vue&type=template&id=670d44bd&scoped=true"
import script from "./CreateIsolatedNetworkForm.vue?vue&type=script&lang=js"
export * from "./CreateIsolatedNetworkForm.vue?vue&type=script&lang=js"

import "./CreateIsolatedNetworkForm.vue?vue&type=style&index=0&id=670d44bd&lang=less&scoped=true"

import exportComponent from "/home/biktorgj/Projects/Linube Cloud/Server_and_UI/ui-prod-4.22/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-670d44bd"]])

export default __exports__